// src/store/rootReducer.ts
import { combineReducers } from "@reduxjs/toolkit";
import formEntriesReducer from "./slices/formEntriesSlice";
import activeFormReducer from "./slices/activeFormSlice";

const rootReducer = combineReducers({
  formEntries: formEntriesReducer,
  activeForm: activeFormReducer,
});

export default rootReducer;
